// extracted by mini-css-extract-plugin
export default {"light":"_4G029E","dark":"xr5oOr","icon":"FbiMq_"};